import type { TFunction } from "i18next";
import { COMPANYADMIN } from "src/common/service/users";

export const getGroupName = (options: { t: TFunction; groupName: string }) => {
	if (options.groupName === COMPANYADMIN) {
		return options.t("CompanyAdmin");
	}
	return options.groupName;
};
